import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { server } from "../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "./Certificate.css";

const FinalPermission = () => {
  const [data, setData] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getData(id);
  }, [id]);

  const getData = (permId) => {
    server
      .get(`/user_appl/userapplication/${permId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch((error) => {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.error || "माहिती लोड करण्यात त्रुटी आली");
        }
      });
  };

  const handlePrint = () => {
    window.print();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return new Date().toLocaleDateString("en-GB");
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    } catch {
      return dateStr;
    }
  };

  const getFestivalDisplayName = (festName) => {
    switch (festName) {
      case "ganesh_utsav":
        return "सार्वजनिक गणेशोत्सव २०२६";
      case "navratri":
        return "नवरात्री उत्सव २०२६";
      case "shiv_jayanti":
        return "शिवजयंती उत्सव २०२६";
      case "ambedkar_jayanti":
        return "डॉ. बाबासाहेब आंबेडकर जयंती २०२६";
      case "other":
        return "उत्सव २०२६";
      default:
        return festName || "सार्वजनिक गणेशोत्सव २०२६";
    }
  };

  // Conditions 1 to 7 for Page 2
  const mnpConditionsPage2 = [
    "मा. शासनाने सार्वजनिक गणेशोत्सव मार्गदर्शक सूचना क्रमांक आरएलपी-०६२१/प्र.क्र. १४४/वि.शा.१ब दि.२९ जून २०२१ अन्वये दिलेल्या मार्गदर्शक सूचनांचे काटेकोरपणे अंमलबजावणी करण्यात यावी.",
    "देण्यात आलेल्या परवानगी पेक्षा जास्त मोजमापाचा मंडप उभारू नये.",
    "सार्वजनिक ठिकाणी मंडप उभारताना स्थानिक रहिवाशांना, सार्वजनिक वाहतूक रहदारी यांना अडथळा व उपद्रव निर्माण होता कामा नये.",
    "सार्वजनिक जागेवर मंडप उभारताना रस्त्याचा किमान ६०% व त्या पेक्षा जास्त भाग वाहतुकीस खुला राहील याची खबरदारी घेण्यात यावी.",
    "सार्वजनिक रस्त्यावर मंडप उभारताना सदर रस्त्यावरून अ‍ॅम्ब्युलन्स, अग्निशमन बंब व इतर अत्यावश्यक सेवेतील वाहने व्यवस्थितरित्या जाऊ शकेल इतका रस्ता खुला ठेवण्यात यावा व मंडपाच्या ठिकाणी अग्निशमन व्यवस्था ठेवणे बंधनकारक आहे.",
    "म.न.पा च्या सार्वजनिक मालमत्तेचे नुकसान झाल्यास ते दंडात्मक कारवाई करून आपणा कडून वसूल करण्यात येईल. सार्वजनिक रस्त्याचे नुकसान केल्यास / मंडप उभारताना रस्ता खोदल्याचे आढळून आल्यास संबंधिताकडून दंडात्मक कारवाई करण्यात येईल.",
    "कुठल्याही प्रकारे सार्वजनिक शांतता भंग होता कामा नये.",
  ];

  // Conditions 8 to 15 for Page 3
  const mnpConditionsPage3 = [
    "उत्सवाच्या काळात कुठल्याही प्रकारची जीवित व वित्तहानी झाल्यास त्यास आपणांस जबाबदार धरून कायदेशीर कारवाई करण्यात येईल.",
    "सदरची परवानगी ही पोलीस प्रशासन, शहर वाहतूक नियंत्रण शाखा या खात्याकडील ना-हरकत परवानगी घेणे अर्जदारावर बंधनकारक राहील या अटीस अधीन राहून परवानगी देण्यात येते.",
    "सहा. धर्मदाय आयुक्त यांचेकडील मंडळाची / ट्रस्टची नोंदणी बंधनकारक आहे.",
    "मा. उच्च न्यायालय मुंबई येथील जनहित याचिका क्र. १५५/२०११ मधील व मा. शासन यांनी दिलेल्या आदेशाचे काटेकोरपणे पालन करण्याची जबाबदारी आपणावर बंधनकारक राहील. तसेच सदर ठिकाणी कोणत्याही प्रकारचे फ्लेक्स बोर्ड, होर्डिंग्ज लावता येणार नाही.",
    "देण्यात आलेल्या परवानगीचा तपशील मंडपाचे दर्शनी भागावर ठळकपणे लावण्यात यावा.",
    "पारंपारिक मिरवणूक मार्गावरील आपण उभारलेला मंडप, आरास, देखावे, पताका, विद्युत रोषणाई, झेंडे, रस्त्याचे बाजूचे मंडपाची झालर इत्यादींमुळे कोणताही अडथळा होता कामा नये.",
    "सदर मंडपामध्ये व परिसरातील मंडपाचे आजूबाजूचे रस्ते छायाचित्रीकरण होईल अशा योग्य रीतीने किमान चार सीसीटीव्ही कॅमेरे बसवून ते अहोरात्र सुरू ठेवण्यात यावे.",
    "मंडपात मोकाट जनावरांमुळे मूर्तीची विटंबना होणार नाही याची दक्षता घेण्यात यावी.",
  ];

  // 5 Years Extension Conditions for Page 3
  const fiveYearsConditions = [
    "संबंधित मंडळाने प्रत्येक वर्षी गणेशोत्सवापूर्वी स्थानिक पोलीस स्टेशनचे ना-हरकत प्रमाणपत्र ऑनलाईन प्रणालीद्वारे सादर करणे आवश्यक राहील.",
    "मुदतवाढीच्या कालावधीत संबंधित मंडळाविरुद्ध कोणतीही तक्रार अथवा नियमभंग निदर्शनास आल्यास मुदतवाढ कोणत्याही पूर्वसूचनेशिवाय रद्द करण्याचे अधिकार महानगरपालिकेस राहतील.",
    "मूळ शासन निर्णय व यापूर्वीच्या परवानगीमध्ये नमूद केलेल्या सर्व अटी व शर्ती व शासनाने दिलेले तसेच मा. न्यायालयाने दिलेले निर्देश मुदतवाढीच्या संपूर्ण कालावधीत लागू राहतील.",
    "सदर मुदतवाढ ही सर्वस्वी प्रशासकीय स्वरूपाची असून, यामुळे संबंधित जागेवर कोणत्याही मंडळास कायमस्वरूपी हक्क अथवा मालकी प्राप्त होणार नाही.",
    "सदरची परवानगी ही फक्त गणेशोत्सव काळातील गणेश मूर्ती स्थापनेकरीता उभारण्यात येणाऱ्या मंडपाकरीता देण्यात आलेली आहे.",
  ];

  // Police Conditions for Page 4
  const policeConditionsPage4 = [
    "सार्वजनिक गणेश मंडळांनी ऑनलाईन नोंदणी करावी / सार्वजनिक गणेश मंडळांनी महावितरण कंपनीकडून अधिकृत तात्पुरती वीज जोडणी करावी.",
    "आक्षेपार्ह घोषवाक्य प्रक्षोभक देखाव्यावरून कोणाच्याही भावना दुखवणार नाही याची दक्षता घ्यावी.",
    "मोठ्या गणेश उत्सव मंडळांनी रहदारीस अडथळा निर्माण होणार नाही याची दक्षता घ्यावी.",
    "ध्वनीक्षेपक वापरावरील निर्बंधाचे अनुषंगाने प्रदूषण नियंत्रण कायद्या अंतर्गत तरतुदींचे तसेच मा. सर्वोच्च न्यायालयाकडील निर्देशांचे काटेकोर पालन करावे.",
    "देखावा पाहण्यासाठी येणाऱ्या महिलांसाठी स्वतंत्र व्यवस्था करण्यात यावी व कोणत्याही प्रकारे छेडछाड होणार नाही याची दक्षता घेऊन स्वयंसेवक नेमावेत.",
    "गणेश स्थापनेमुळे इतर धर्मियांचे धार्मिक स्थळास कोणत्याही प्रकारे अडथळा होणार नाही याची दक्षता घ्यावी.",
    "मिरवणुकीत वापरण्यात येणारी वाहने सुस्थितीत असले बाबत अगोदरच आरटीओ कडून तपासणी करून घ्यावी.",
    "संबंधित वाहनावरील चालक हा देखील लायसन्सधारक असावा त्याने मद्यार्काचे सेवन केलेले नसावे.",
    "स्थापना मिरवणूक / विसर्जन मिरवणूक काढणार असल्याचे त्यांचे व्हीडिओ शुटींग करावे तसेच आवश्यकता भासल्यास पोलीसांना द्यावे.",
    "कोणत्याही प्रकारच्या बॅग पिशव्या मंडपात दर्शनाच्या ठिकाणी आणण्यास प्रतिबंध करावा.",
    "काही संशयित वस्तू मंडळाचे आसपास आढळल्यास त्याबाबत तात्काळ पोलीसांना संपर्क करावा व शक्यतो अशा वस्तू हाताळू नये.",
    "श्री गणेश प्रतिष्ठापनेचा मंडप भक्कम व उंच असावा.",
    "श्री गणेशोत्सव मंडळापासून किमान ५० मीटरच्या आत वाहने ठेवू नये, ५० मीटरच्या वर अंतरावर पार्किंगची व्यवस्था करण्यात यावी.",
    "श्री गणेश मूर्तीच्या संरक्षणाकरीता २४ तास स्वयंसेवकाची नेमणूक करण्यात यावी.",
    "मंडळाने सर्व एरिया कव्हर होईल अशा प्रकारे सीसीटीव्ही कॅमेरे बसवावेत.",
    "विनापरवाना वर्गणी गोळा करू नये, तसेच वर्गणी गोळा करताना कोणत्याही प्रकारे बळजबरी करू नये असे निदर्शनास आल्यास कायदेशीर कारवाई करण्यात येईल.",
    "श्री गणेश तरुण मंडळाचे वतीने टाकण्यात आलेले मंडप पूर्व परवानगी घेऊन व नियमानुसार टाकावे. अनाधिकृत मंडप टाकल्यास योग्य ती कायदेशीर कारवाई करण्यात येईल.",
    "गणेश उत्सव मंडळाने अनाधिकृत फ्लेक्स, जाहिराती फलक लावू नये तसेच त्यावर आक्षेपार्ह मजकूर छापू नये.",
    "पोलीस स्टेशनला गणेश विसर्जनाच्या ठिकाणाची माहिती द्यावी. विसर्जन करताना धोकादायक विहीर अथवा जलस्त्रोत या ठिकाणी गणेश विसर्जन करू नये. अशा ठिकाणी अपघात होण्याची शक्यता असते. त्याबाबत काळजी घ्यावी.",
    "वरील पैकी कुठल्याही अटी व शर्तीचा भंग झाल्यास अथवा तक्रार प्राप्त झाल्यास दिलेला परवाना त्वरित रद्द करण्यात येईल.",
  ];

  // Common Header Component
  const renderHeader = () => (
    <Row className="cert-header align-items-center">
      <Col xs={2} className="text-center">
        <Image src="/logo1.jpeg" className="cert-logo" alt="AMC Logo" />
      </Col>
      <Col xs={8} className="text-center">
        <h1 className="cert-dept-title">अहिल्यानगर महानगरपालिका, अहिल्यानगर</h1>
        <p className="cert-dept-subtitle">अनाधिकृत बांधकाम नियंत्रण व अतिक्रमण निर्मूलन विभाग</p>
        <p className="cert-dept-hq">(मुख्यालय)</p>
        <div className="cert-contact-info">
          वेबसाईट: <strong>www.amc.gov.in</strong> | ई-मेल: <strong>amc_anr@rediffmail.com</strong> / <strong>encroachment.amc1@gmail.com</strong>
        </div>
      </Col>
      <Col xs={2} className="text-center">
        <Image src="/bharat.jpeg" className="cert-logo" alt="Bharat Logo" />
      </Col>
    </Row>
  );

  return (
    <div className="permission-page-wrapper">
      {data.permission_status === "APPROVED" ? (
        <>
          {/* Action Bar (Print / Back) */}
          <div className="permission-action-bar">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => navigate(-1)}
            >
              <i className="fas fa-arrow-left me-1"></i> मागे जा (Back)
            </Button>
            <Button
              onClick={handlePrint}
              className="btn-print-action"
            >
              <i className="fas fa-print me-2"></i> प्रिंट करा (Print A4 Certificate)
            </Button>
          </div>

          {/* =========================================================
              A4 PAGE 1: मंडळ परवाना कार्ड (Display Pass Certificate)
              ========================================================= */}
          <div className="a4-page">
            <div>
              {renderHeader()}

              <div className="mandap-pass-box text-center">
                <h2 className="festival-title-main">
                  {getFestivalDisplayName(data.festival_name)}
                </h2>
                <h4 className="fw-bold mb-3">अहिल्यानगर महानगरपालिका, अहिल्यानगर</h4>
                <div className="pass-detail-row">
                  <strong>मंडळ परवाना क्र :</strong> जा क्र: {data.id || "---"}/२०२६
                </div>
                <div className="pass-detail-row">
                  <strong>गणेश मंडळाचे नाव :</strong> {data.mandal_name || "---"}
                </div>
                <div className="pass-detail-row">
                  <strong>अध्यक्षांचे नाव :</strong> {data.name || data.applicant_name || "---"}
                </div>
                <div className="pass-detail-row">
                  <strong>मंडपाचे ठिकाण :</strong> {data.mandap_address || "---"}
                </div>
                <div className="pass-detail-row">
                  <strong>परवाना कालावधी :</strong> दि. {data.mandap_startdate || "१४/०९/२०२६"} ते {data.mandap_remove_date || "२५/०९/२०२६"} ({data.mandap_duration ? `${data.mandap_duration} दिवस` : "---"})
                </div>
                <div className="pass-detail-row">
                  <strong>मंडप मोजमाप :</strong> {data.mandap_length || "---"} X {data.mandap_width || "---"} फूट
                </div>
              </div>
            </div>

            <div className="cert-signature-block">
              <img src="/sign.png" className="esign-img" alt="Digital Signature" />
              <p className="sign-name">आदित्य कल्याण बल्लाळ</p>
              <p className="sign-role">कनिष्ठ अभियंता तथा अतिक्रमण निर्मूलन विभाग प्रमुख</p>
              <p className="sign-corp">अहिल्यानगर महानगरपालिका, अहिल्यानगर</p>
            </div>

            <div className="page-footer-num">पृष्ठ १ पैकी ४ (मंडळ परवाना प्रमाणपत्र)</div>
          </div>

          {/* =========================================================
              A4 PAGE 2: अधिकृत आदेश व महानगरपालिका अटी (क्र. १ ते ७)
              ========================================================= */}
          <div className="a4-page">
            <div>
              {renderHeader()}

              <div className="letter-meta">
                <span>जा क्र: {data.id || "---"}/२०२६</span>
                <span>दिनांक :- {formatDate(data.created_at)}</span>
              </div>

              <div className="letter-recipient">
                <strong>प्रति,</strong><br />
                श्री. <strong>{data.name || data.applicant_name || "---"}</strong><br />
                अध्यक्ष :- <strong>{data.mandal_name || "---"}</strong><br />
                अहिल्यानगर.
              </div>

              <div className="letter-subject">
                <strong>विषय :- {getFestivalDisplayName(data.festival_name)}</strong><br />
                सार्वजनिक जागेवर गणेशोत्सवा निमित्त तात्पुरता मंडप उभारण्यास परवानगी मिळणे बाबत.
              </div>

              <div className="letter-reference">
                <strong>संदर्भ :-</strong> आपला दि. <strong>{formatDate(data.created_at)}</strong> रोजीचा अर्ज
              </div>

              <div className="letter-body-intro">
                उपरोक्त संदर्भीय अर्जानुसार कळविण्यांत येते की, सार्वजनिक जागेवर गणेशोत्सवा निमित्त मंडप उभारण्यास आपण परवानगी मागितलेली आहे. आपल्या विनंतीनुसार <strong>{data.mandap_address || "---"}</strong> या ठिकाणी दि. <strong>{data.mandap_startdate || "१४/०९/२०२६"}</strong> ते <strong>{data.mandap_remove_date || "२५/०९/२०२६"}</strong> या कालावधीत <strong>{data.mandap_length || "---"} X {data.mandap_width || "---"} फूट</strong> या मोजमापाचे मंडपास खालील अटीस व शर्तीस अधीन राहून परवानगी देण्यात येत आहे.
              </div>

              <h5 className="condition-heading">महानगरपालिका अटी व शर्ती :</h5>
              <ol className="condition-list">
                {mnpConditionsPage2.map((cond, idx) => (
                  <li key={idx}>{cond}</li>
                ))}
              </ol>
            </div>

            <div className="page-footer-num">पृष्ठ २ पैकी ४ (अधिकृत आदेश)</div>
          </div>

          {/* =========================================================
              A4 PAGE 3: म.न.पा. उर्वरित अटी (८ ते १५) व ५ वर्षे मुदतवाढ
              ========================================================= */}
          <div className="a4-page">
            <div>
              {renderHeader()}

              <h5 className="condition-heading">महानगरपालिका अटी व शर्ती (पुढे चालू) :</h5>
              <ol className="condition-list" start={8}>
                {mnpConditionsPage3.map((cond, idx) => (
                  <li key={idx + 8}>{cond}</li>
                ))}
              </ol>

              <h5 className="condition-heading text-danger mt-3">
                सदरची परवानगी पुढील पाच वर्षांकरीता कायम राहणेकरीता पुढील अटी शर्ती लागू राहतील :
              </h5>
              <ol className="condition-list">
                {fiveYearsConditions.map((cond, idx) => (
                  <li key={idx}>{cond}</li>
                ))}
              </ol>
            </div>

            <div className="page-footer-num">पृष्ठ ३ पैकी ४ (नियम व अटी)</div>
          </div>

          {/* =========================================================
              A4 PAGE 4: पोलीस सूचना व अंतिम स्वाक्षरी
              ========================================================= */}
          <div className="a4-page">
            <div>
              {renderHeader()}

              <h5 className="condition-heading police-heading text-primary">
                पोलीस प्रशासनाकडील खालील सूचनांचे गणेशोत्सव सर्व मंडळांनी पालन करावे :
              </h5>
              <ol className="condition-list police-condition-list">
                {policeConditionsPage4.map((cond, idx) => (
                  <li key={idx}>{cond}</li>
                ))}
              </ol>
            </div>

            <div className="cert-signature-block">
              <img src="/sign.png" className="esign-img" alt="Digital Signature" />
              <p className="sign-name">आदित्य कल्याण बल्लाळ</p>
              <p className="sign-role">कनिष्ठ अभियंता तथा अतिक्रमण निर्मूलन विभाग प्रमुख</p>
              <p className="sign-corp">अहिल्यानगर महानगरपालिका, अहिल्यानगर</p>
            </div>

            <div className="page-footer-num">पृष्ठ ४ पैकी ४ (अंतिम स्वाक्षरी)</div>
          </div>
        </>
      ) : (
        <Container className="text-center py-5">
          <div className="card shadow-sm p-4 border-0 rounded-4 mx-auto" style={{ maxWidth: "500px" }}>
            <i className="fas fa-clock text-warning fa-3x mb-3"></i>
            <h4 className="fw-bold">परवानगी अद्याप मंजूर झालेली नाही</h4>
            <p className="text-muted">
              आपल्या अर्जाची सद्यस्थिती: <strong>{data.permission_status || "PENDING"}</strong>
            </p>
            <Button variant="primary" onClick={() => navigate("/trackapplication")}>
              अर्जाची स्थिती तपासा
            </Button>
          </div>
        </Container>
      )}
    </div>
  );
};

export default FinalPermission;
